import { ApiClient } from './api-client';
import { useObsConfig } from '../obs-config/UseObsConfig';
import { useMemo } from 'react';
import qs from 'qs';

export function useApiClient(): ApiClient {
  const obsCofnig = useObsConfig();
  const client = useMemo(
    () =>
      new ApiClient({
        baseURL: obsCofnig.urlOrigin,
        withCredentials: false,
        responseType: 'json',
        timeout: 30000,
        paramsSerializer: {
          serialize: (params: any): string => qs.stringify(params, { arrayFormat: 'brackets' }),
        },
      }),
    [obsCofnig.urlOrigin],
  );

  return client;
}
